import { NgModule } from '@angular/core';
import { addNavMenuItem, SharedModule } from '@vendure/admin-ui/core';

@NgModule({
    imports: [SharedModule],
    providers: [
        addNavMenuItem(
            {
                id: 'assisted-sales',
                label: 'Vendas assistidas',
                routerLink: ['/extensions/assisted-sales'],
                icon: 'search',
            },
            'sales'
        ),
    ],
})
export class AssistedSalesNavModule {}
